export const Role = {
  admin: { value: 'admin', label: 'Admin' },
  user: { value: 'user', label: 'User' },
};

export const FileType = {
  LOAN: { value: 'loan', label: 'Loan' },
  PAYMENT: { value: 'payment', label: 'Payment' },
  OTHER: { value: 'other', label: 'Other' },
};

export const WorkflowInputType = {
  FILE: { value: 'file', label: 'Document' },
  WORKFLOW: { value: 'workflow', label: 'Workflow' },
};

export const JobWorkflowStatus = {
  IN_PROGRESS: { value: 'in_progress', label: 'In Progress' },
  COMPLETED: { value: 'completed', label: 'Completed' },
  PENDING: { value: 'pending', label: 'Pending' },
  FAILED: { value: 'failed', label: 'Failed' },
  NEEDS_REVIEW: { value: 'needs_review', label: 'Needs Review' },
};

export const JobStatus = {
  IN_PROGRESS: { value: 'in_progress', label: 'In Progress' },
  COMPLETED: { value: 'completed', label: 'Completed' },
  PENDING: { value: 'pending', label: 'Pending' },
  FAILED: { value: 'failed', label: 'Failed' },
  NEEDS_REVIEW: { value: 'needs_review', label: 'Needs Review' },
};
export const JobWorkflowTaskStatus = {
  PENDING: { value: 'pending', label: 'Pending' },
  IN_PROGRESS: { value: 'in_progress', label: 'In Progress' },
  COMPLETED: { value: 'completed', label: 'Completed' },
  FAILED: { value: 'failed', label: 'Failed' },
  INTERVENTION_NEEDED: { value: 'intervention_needed', label: 'Intervention Needed' },
};

export const JobExceptionStatus = {
  PENDING: { value: 'pending', label: 'Pending' },
  SKIPPED: { value: 'skipped', label: 'Skipped' },
  TRANSACTION_MADE: { value: 'transaction_made', label: 'Transaction Made' },
};

export const DocumentType = {
  RATE_SHEET: { value: 'rate_sheet', label: 'Rate Sheet' },
  OTHER_DOCUMENTS: { value: 'other', label: 'Other Documents' },
};

export const DocumentStatus = {
  UPLOADING: { value: 'uploading', label: 'Uploading' },
  ACTIVE: { value: 'active', label: 'Active' },
  IN_ACTIVE: { value: 'in_active', label: 'In Active' },
  CANCELLED: { value: 'cancelled', label: 'Cancelled' },
};
export const AssistantType = {
  JOB_ASSISTANT: { value: 'job_assistant', label: 'Job Assistant' },
  TASK_ASSISTANT: { value: 'task_assistant', label: 'Task Assistant' },
};

export const SUMMARY_PROMPTS = [
  'add to loan pricing summary',
  'Include this in the loan pricing summary',
  'Update the loan pricing summary with this information',
  'Add this content to the loan pricing summary section',
  'Add a new row to the loan pricing summary',
  'Append a new summary to the loan pricing summary',
  'Insert a new entry into the loan pricing summary',
];

export const JOB_DETAILS_TABS = {
  DETAILS: 'details',
  DASHBOARD: 'dashboard',
  ASSISTANT: 'assistant',
  DOCUMENTS: 'documents',
  ACTIVITY_LOG: 'activity_log',
};

export const FUND_ALLOCATION_TABS = {
  FUND_ALLOCATION: 'fund_allocation',
  FUND_MASTER: 'fund_master',
  CONFIGURATION: 'configuration',
};
